"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitTicketForApprovalResponseSchema = exports.submitTicketForApprovalRequestSchema = exports.submitTicketPreviewResponseSchema = exports.approvalRuleSnapshotSchema = void 0;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
exports.approvalRuleSnapshotSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    required_approvers: zod_1.z.array(approval_rules_1.pgApproverRoleSchema),
    mode: approval_rules_1.approvalModeSchema,
});
exports.submitTicketPreviewResponseSchema = zod_1.z.discriminatedUnion('outcome', [
    zod_1.z.object({ outcome: zod_1.z.literal('match'), rule: exports.approvalRuleSnapshotSchema }),
    zod_1.z.object({ outcome: zod_1.z.literal('no_match') }),
]);
exports.submitTicketForApprovalRequestSchema = zod_1.z.object({
    expected_updated_at: zod_1.z.string().min(1),
});
exports.submitTicketForApprovalResponseSchema = zod_1.z.object({
    ticket: zod_1.z.object({
        id: zod_1.z.string(),
        status: zod_1.z.string(),
        submitted_at: zod_1.z.string(),
        updated_at: zod_1.z.string(),
    }),
    workflow: zod_1.z
        .object({
        id: zod_1.z.string().uuid(),
        rule_id: zod_1.z.string().uuid(),
        rule_label: zod_1.z.string(),
        required_approvers: zod_1.z.array(approval_rules_1.pgApproverRoleSchema),
        mode: approval_rules_1.approvalModeSchema,
        created_at: zod_1.z.string(),
    })
        .nullable(),
});
//# sourceMappingURL=submit-ticket-for-approval.js.map